import { render, staticRenderFns } from "./scale-screen.vue?vue&type=template&id=8ac9e142&scoped=true&"
import script from "./scale-screen.vue?vue&type=script&lang=js&"
export * from "./scale-screen.vue?vue&type=script&lang=js&"
import style0 from "./scale-screen.vue?vue&type=style&index=0&id=8ac9e142&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac9e142",
  null
  
)

export default component.exports